/**
 * The default component that shows nothing.
 * @constructor
 */
export const NullComponent = () => {
  return null
}
